import { NavItem } from './nav-item';
import LoadingAnimation from "../loading/loading";
import _ from 'lodash';
import { useMenus } from '../../app';

const SidebarNav = () => {
	
	const menus = useMenus();

	const menuItems = items => {

		const menuItems = _.filter(items, item => item && item.rolesRequired && item.rolesRequired.indexOf("Application.Developer") === -1);

		return menuItems.map((menu, i) => (
			<NavItem key={i} menu={menu} />
		))
	};

	return (
		<div className="menu">
			{menus && <div className="menu-header">Navigation</div>}
			{menus && menuItems(menus)}
			{!menus && <LoadingAnimation />}
		</div>
	)
}

export default SidebarNav;